/**
 * TanStack Query hooks for `per-campaign-fraud-toggle-threshold-sliders`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	perCampaignFraudToggleThresholdSlidersQueryKeys,
	type CreatePerCampaignFraudToggleThresholdSlidersBody,
	type ListPerCampaignFraudToggleThresholdSlidersResponse,
	type PerCampaignFraudToggleThresholdSlidersRow,
} from "./api";

export function usePerCampaignFraudToggleThresholdSlidersList(): UseQueryResult<ListPerCampaignFraudToggleThresholdSlidersResponse, Error> {
	return useQuery({
		queryKey: perCampaignFraudToggleThresholdSlidersQueryKeys.list(),
		queryFn: list,
	});
}

export function usePerCampaignFraudToggleThresholdSlidersCreate(): UseMutationResult<PerCampaignFraudToggleThresholdSlidersRow, Error, CreatePerCampaignFraudToggleThresholdSlidersBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perCampaignFraudToggleThresholdSlidersQueryKeys.all });
		},
	});
}

export function usePerCampaignFraudToggleThresholdSlidersDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perCampaignFraudToggleThresholdSlidersQueryKeys.all });
		},
	});
}
